import locale from '@@i18n/locales/hu.json';

export const propertiesList = Array.from({ length: Object.keys(locale.properties).length }, (_, i) => 'properties.' + i);
